<template src="./onlineTestAssignStudents.html"></template>

<script>
import showStatus from '../../../NetworkManager/showStatus'
// import { createExcelThroughJsonForMultipleSheets, generateJsonFromExcel } from '../../../utils/excel';
// import { v4 } from "uuid"
import SemesterUserRepository from "../../../Repository/SemesterUser";
import UserRepository from "../../../Repository/User";
import apiV3 from "../../../NetworkManager/apiV3";
export default {
  name: "onlineTestAssignStudents",
  props: [
    "prop_selectedSubject",
    "prop_selectedSubjectId",
    "prop_tabNumber",
    "prop_allSubjects",
    "prop_selectedItem"
  ],
  data() {
    return {
      testId: "",
      studentDialogHeaders: [
        { text: "Selected", value: "selected", width: "2%" },
        { text: "Prn", value: "collegePRNNo", align: "center", width: "10%" },
        { text: "Roll No.", value: "rollNumber", align: "center", width: "10%" },
        { text: "Student Name  ", value: "studentName", align: "center", width: "35%" }
      ],
      filteredStudents: [],
      testSelection: {},
      studentsForTest: [],
      selectAllStudents: false,
      userDetails: [],
      allowedStudents: [],
      isAllocatedStudent: false,
      test: {},
      studentIds: [],
      studentAnswers: [],
      resubmissionAnswerIds: [],
      saveChanges: false,
      selectedObjectTest: {},
      isDisabled: false
    };
  },
  async created() {
    await this.initializeTestDetails();
  },
  async activated() {
    const { basicDetails, questions, studentAllocation } = this.$store.state.liveData.testDetailsChanged;

    if (basicDetails || questions || studentAllocation) {
      await this.executeTestProcesses();
    }
  },
  methods: {
    async initializeTestDetails() {
      try {
        this.userData = this.$store.getters["user/get_userData"];
        this.selectedDepartment = this.$store.getters["liveData/get_examDepartment"];
        this.semesterUserRepositoryInstance = new SemesterUserRepository(this);
        this.userRepositoryInstance = new UserRepository(this);
        this.selectedCourseYear = this.$store.getters["liveData/get_examCourseYear"];
        this.selectedInstitute = this.$store.getters["instituteData/get_selectedInstitute"];
        this.selectedSemester = this.$store.getters["instituteData/get_selectedSemester"];
        this.testId = this.$store.getters["liveData/get_testId"];
        this.testSelection = this.$store.getters["liveData/get_selectedObjectTest"];
        this.selectedObjectTest = this.$store.getters["liveData/get_selectedObjectTest"];

        if (this.selectedObjectTest?.editTest) {
          const testDate = this.selectedObjectTest?.prop_onlineTest?.dateTimeUTC;
          if (testDate && new Date(testDate) < new Date()) {
            this.isDisabled = true;
          }
        }

        await this.executeTestProcesses();
      } catch (error) {
        console.error("Error during test initialization", error);
      }
    },

    async executeTestProcesses() {
      try {
        await this.fetchTest();
        await this.getStudents();
        await this.getUsersDetails();
        await this.fillStudentAllocation();
        await this.compareDates();
        await this.compareEndDateTime();
      } catch (error) {
        console.error("Error during test processes execution", error);
      }
    },
    async fetchTest() {
      try {
        this.test = await apiV3.postRequest('/exam/getExamById', { testId: this.testId });
      } catch (error) {
        console.error('error', error);
      }
    },
    compareDates() {
      const date = new Date(this.test.data.dateTimeUTC);
      date.setMinutes(date.getMinutes() + Number(this.test.data.durationInMins));
      if (date.toISOString() < new Date().toISOString()) {
        const newHeader = { text: "Allow Reattempt to student", value: "reattempt", align: "center", width: "15%" };
        if (!this.studentDialogHeaders.some(header => header.value === newHeader.value)) {
            this.studentDialogHeaders.push(newHeader);
        }
      };
    },
    compareEndDateTime() {
      const date = new Date(this.test.data.endDateAndTime);
      date.setMinutes(date.getMinutes());
      if (date.toISOString() < new Date().toISOString()) {
        if (this.studentDialogHeaders[this.studentDialogHeaders.length - 1].text === "Allow Reattempt to student") {
          this.studentDialogHeaders.pop()
        }
      };
    },
    addMinutesToDate(dateString, minutes) {
      const date = new Date(dateString); // Convert the string to a Date object
      date.setMinutes(date.getMinutes() + minutes); // Add the given minutes
      return date.toISOString(); // Return the updated date in ISO format
    },
    // async fetchTestAnswers() {
    //   this.studentIds = this.test?.data?.allowedStudents;
    //   try {
    //     this.studentAnswers = await apiV3.postRequest('/exam/getAnswersByStudentsAndExam', {
    //       studentIds: this.studentIds,
    //       examId: this.testId
    //     });
    //   } catch (error) {
    //     console.error('error', error);
    //   }
    //   console.log('this.studentAnswers', this.studentAnswers);
    //   this.allowedStudents.forEach(student => {
    //     const submittedAnswer = this.studentAnswers.find(answer => answer.studentId === student.uId);
    //     this.$set(student, 'isTestSubmitted', !!submittedAnswer);
    //     this.$set(student, '_id', submittedAnswer ? submittedAnswer._id : null);
    //   });
    //   console.log('this.allowedStudents', this.allowedStudents);
    // },
    fillStudentAllocation() {
      this.allowedStudents.forEach(student => {
        this.$set(student, 'isSelected', this.test?.data?.allowedStudents?.some(allowedStudent => allowedStudent.uId === student.uId));
      });
    },
    handleBufferTime(item) {
      console.log("Clicked item:", item);
    },
    handleResubmission(item) {
      this.saveChanges = true;
      console.log("Clicked item 2:", item);
      this.resubmissionAnswerIds.push(item.uId);
      this.$set(item, 'reattempt', true);
    },
    async getStudents() {
      try {
        let FilterObject
        if (this.testSelection.prop_typeDivGrpBatch === "Division" || this.testSelection.prop_typeDivGrpBatch === "Batch") {
            FilterObject = {
                instituteId: this.selectedInstitute,
                semId: this.selectedSemester.semId,
                department: this.testSelection.prop_department,
                courseYear: this.testSelection.prop_course,
                division: this.testSelection.prop_selectedDivision,
                subjectId: this.testSelection.prop_selectedSubject.subjectId
            }
            if (this.testSelection.prop_typeDivGrpBatch === "Batch") {
                FilterObject.batch = this.testSelection.prop_selectedBatch;
            }

            this.studentsForTest =
                await this.semesterUserRepositoryInstance.getSemesterUsersOfASubjectOfADivision(
                    FilterObject
                );
        } else if (this.testSelection.prop_typeDivGrpBatch === "Group") {
            FilterObject = {
                instituteId: this.selectedInstitute,
                semId: this.selectedSemester.semId,
                department: this.testSelection.prop_department,
                courseYear: this.testSelection.prop_course,
                subjectId: this.testSelection.prop_selectedSubject.subjectId,
                groupId: this.testSelection.prop_selectedGroup.groupId
            }
            this.studentsForTest =
                await this.semesterUserRepositoryInstance.getSemesterUsersOfASubjectOfAGroup(
                    FilterObject
                );
        }
      } catch (error) {
        console.error('error', error);
        this.studentsForTest = [];
      }
    },
    selectAllItems() {
        this.isAllocatedStudent = true
      this.allowedStudents.forEach(item => {
        item.isSelected = this.selectAllStudents;
      });
    },
    async getUsersDetails() {
      try {
        const uIds = this.studentsForTest.map((item) => item.uId);
        const userData = await this.userRepositoryInstance.getUsers({ uIds });
        const userDetailsMap = new Map(
        userData.map((user) => [user.uId, user])
        );
        this.allowedStudents = this.studentsForTest.map(student => {
          const allowedStu = this.test.data?.allowedStudents?.find(allowed => allowed.uId === student.uId);
          const studentDetails = userDetailsMap.get(student.uId) || {};

          if (allowedStu) {
            return {
              ...studentDetails,
              uId: student.uId,
              rollNumber: student.rollNumber,
              prnNumber: studentDetails.collegePRNNo || null,
              examSeatNumber: studentDetails.examSeatNumber || null,
              studentName: `${studentDetails.firstName || ""} ${studentDetails.lastName || ""}`.trim(),
              reattempt: allowedStu.reattempt
            };
          }

          return {
            ...studentDetails,
            uId: student.uId,
            rollNumber: student.rollNumber,
            prnNumber: studentDetails.collegePRNNo || null,
            examSeatNumber: studentDetails.examSeatNumber || null,
            studentName: `${studentDetails.firstName || ""} ${studentDetails.lastName || ""}`.trim()
          };
        });
      } catch (error) {
          console.error('error', error);
      }
    },
    async saveStudentAllocation() {
      const testDetailsChanged = this.$store.state.liveData.testDetailsChanged;
      testDetailsChanged.studentAllocation = true;
      this.$store.commit("liveData/set_testDetailsChanged", testDetailsChanged);
        if (this.isAllocatedStudent || this.resubmissionAnswerIds.length > 0) {
          console.log('this.allowedStudents', this.allowedStudents, this.resubmissionAnswerIds);
          const studentAllocationArray = this.allowedStudents
            .filter(item => item.isSelected)
            .map(item => {
              return {
                uId: item.uId,
                reattempt: this.resubmissionAnswerIds.includes(item.uId) ? true : null,
                attemptTime: this.resubmissionAnswerIds.includes(item.uId) ? new Date().toISOString() : null
              };
            });
            const testObject = {}
            testObject.examId = this.testId
            testObject.status = "published"
            testObject.allowedStudents = studentAllocationArray
            testObject.examId = this.test?.data._id
            try {
              const updatedStudentAllocation = await apiV3.putRequest("/exam/update", testObject);
              if (updatedStudentAllocation && this.resubmissionAnswerIds.length > 0) showStatus("Reattempt given", 2000, "success", this);
              else if (updatedStudentAllocation && this.resubmissionAnswerIds.length === 0) {
                if (studentAllocationArray.length > 0) {
                  showStatus("Students allocation successful", 2000, "success", this);
                } else {
                  showStatus("Students removed successfully", 2000, "success", this);
                }
              } else showStatus("Error in students allocation", 4000, "error", this);
            this.isAllocatedStudent = false
            this.resubmissionAnswerIds = []
          } catch (error) {
            console.error('error', error);
          }
        } else showStatus("No changes in allocation", 2000, "warning", this);
    }
  }
};
</script>

<style src="./onlineTestAssignStudents.css"></style>
